import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, empty, from, throwError, of} from 'rxjs';
import {Agent} from '../classes/agent';
import { PreRenderService } from '../services/pre-render.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Office } from '../classes/office';
import { AgentResolver } from './agent-resolver';
import { OfficeService } from '../services/office.service';

@Injectable()
export class AgentOfficeResolver implements Resolve<{ agent: Agent, office?: Office }> {

  constructor(private _agentResolver: AgentResolver, private _officeService: OfficeService, private _router: Router, private _preRenderService: PreRenderService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<{ agent: Agent, office?: Office }> {
    // Resolve the agent data, then get the corresponding office data
    // If office fetch fails, still return the agent
    return this._agentResolver.resolve(route, rstate).pipe(
      switchMap((agent, index) => {
        return from(this._officeService.getOfficeDetails('' + agent.remaxOfficeId, true)).pipe(
          map(office => ({agent, office})),
          catchError((err) => {
            return of({agent});
          })
        );
      }),
      catchError((err, caught) => {
        this._router.navigate(['/find-agent-or-office/agent']);
        this._preRenderService.setPreRenderFlag(301, 'find-agent-or-office/agent');
        return empty();
      })
    )
  }
}
